import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import { Col, Row } from "react-bootstrap";
import { faGaugeHigh } from "@fortawesome/free-solid-svg-icons";
import SellerBlock from "../../Components/Stats/SellerBlock";
import StoreByOrderCount from "../../Components/Stats/StoreByOrderCount";
import OrderCountByDays from "../../Components/Stats/OrderCountByDays";
import PageHeader from "../../Components/Common/PageHeader";

const Dashboard = () => {
  const { currentUser } = useAuth();

  const overviewCards = [
    {
      title: "Operational visibility",
      description: "Monitor order flow, storefront health, and channel activity from one place.",
    },
    {
      title: "Faster triage",
      description: "Key actions and problem areas surface early with a cleaner, denser control layout.",
    },
    {
      title: currentUser?.admin ? "Admin workspace" : "Collaborative workspace",
      description: currentUser?.admin
        ? "You have access to account-wide controls, workspace setup, and operational settings."
        : "You can work across stores, orders, and shared resources with clearer navigation.",
    },
  ];

  return (
    <main className="page-main">
      <div className="main-container container">
        <PageHeader
          title="Operations Dashboard"
          description="A cleaner control center for live order trends, storefront performance, and daily execution."
          icon={faGaugeHigh}
          breadcrumb="Control center"
        >
          <div className="page-meta-chip">
            {currentUser?.admin ? "Administrator access" : "Team workspace"}
          </div>
        </PageHeader>

        <section className="dashboard-overview-grid mb-4">
          {overviewCards.map((card, index) => (
            <article className="overview-card" key={card.title}>
              <span className="overview-card-index">0{index + 1}</span>
              <h3>{card.title}</h3>
              <p>{card.description}</p>
            </article>
          ))}
        </section>

        {currentUser?.admin ? (
          <Row>
            <Col md={12}>
              <SellerBlock />
            </Col>
          </Row>
        ) : (
          <></>
        )}

        <Row className="g-4">
          <Col md={4}>
            <StoreByOrderCount />
          </Col>
          <Col md={8}>
            <OrderCountByDays />
          </Col>
        </Row>
      </div>
    </main>
  );
};

export default Dashboard;
